import { useEffect } from "react";
import { useSocketStore } from "./useSocketStore";
import { socket } from "./socket";

const SHORTCUTS = {
  copy: [
    {
      keys: ["Control", "c"],
      details: "Raccourci clavier: Ctrl+C",
    },
    {
      keys: ["Meta", "c"],
      details: "Raccourci clavier: Cmd+C",
    },
    
  ],
  screenshot: [
    {
      keys: ["PrintScreen"],
      details: "Touche PrintScreen (Windows)",
    },
    {
      keys: ["Alt", "PrintScreen"],
      details: "Raccourci clavier: Alt+PrintScreen (Windows)",
    },
    {
      keys: ["Control", "Shift", "PrintScreen"],
      details: "Raccourci clavier: Ctrl+Shift+PrintScreen (Windows/Linux)",
    },
    {
      keys: ["Meta", "Shift", "s"],
      details: "Raccourci clavier: Win+Shift+S (Windows)",
    },
    {
      keys: ["Meta", "PrintScreen"],
      details: "Raccourci clavier: Win+PrintScreen (Windows)",
    },
    {
      keys: ["Meta", "Shift", "3"],
      details: "Raccourci clavier: Cmd+Shift+3 (Mac)",
    },
    {
      keys: ["Meta", "Shift", "4"],
      details: "Raccourci clavier: Cmd+Shift+4 (Mac)",
    },
    {
      keys: ["Meta", "Shift", "5"],
      details: "Raccourci clavier: Cmd+Shift+5 (Mac)",
    },
    {
      keys: ["Control", "Alt", "PrintScreen"],
      details: "Raccourci clavier: Ctrl+Alt+PrintScreen (Linux)",
    },
    {
      keys: ["F11"],
      details: "Touche F11 (Fullscreen)",
    },
  ],
} as const;

const isKeyCombo = (event: KeyboardEvent, keys: string[]): boolean => {
  return keys.every(key => {
    switch (key) {
      case "Control":
        return event.ctrlKey;
      case "Meta":
        return event.metaKey;
      case "Alt":
        return event.altKey;
      case "Shift":
        return event.shiftKey;
      default:
        return event.key === key;
    }
  });
};

export const useCopyDetection = () => {
  const { connected } = useSocketStore();

  const getSelectedText = (): string => {
    return document.getSelection()?.toString() || "";
  };

  useEffect(() => {
    if (!connected) return;

    const handleCopy = (e: KeyboardEvent) => {
      for (const shortcut of SHORTCUTS.copy) {
        if (isKeyCombo(e, [...shortcut.keys])) {
          const selectedText = getSelectedText();
          socket.emit("alert", {
            type: "COPY",
            details: shortcut.details,
            copiedText: selectedText,
          });
          return;
        }
      }
    };

    const handleCopyEvent = () => {
      const selectedText = getSelectedText();

      socket.emit("alert", {
        type: "COPY",
        copiedText: selectedText,
        details: "Copie détectée",
      });
    };

    const handleRightClick = () => {
      socket.emit("alert", {
        type: "COPY",
        details: "Tentative de clic droit",
      });
    };

    const handleScreenshot = (e: KeyboardEvent) => {
      for (const shortcut of SHORTCUTS.screenshot) {
        if (isKeyCombo(e, [...shortcut.keys])) {
          socket.emit("alert", {
            type: "SCREENSHOT",
            details: shortcut.details,
          });
          return;
        }
      }
    };

    // Add event listeners
    window.addEventListener("keydown", handleCopy);
    window.addEventListener("keydown", handleScreenshot);
    document.addEventListener("copy", handleCopyEvent);
    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      window.removeEventListener("keydown", handleCopy);
      window.removeEventListener("keydown", handleScreenshot);
      document.removeEventListener("copy", handleCopyEvent);
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, [connected]);
};
